import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { ImageWrapper } from '~components/BotAvatar/BotAvatar.styles';
import { MqTablet } from '~theme/media';

export const MessageListHeaderOuter = styled.div`
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	padding-right: var(--base-gap);
	padding-left: var(--base-gap);
	gap: 10px;
	grid-area: header;

	${ImageWrapper} {
		--avatar-size: 48px;
		img {
			width: 100%;
			height: 100%;
		}
	}

	${MqTablet} {
		display: none;
		gap: 12px;
	}

	p {
		display: flex;
		align-items: center;
		column-gap: 5px;
	}
`;

export const MessageListContent = styled.div`
	display: flex;
	flex: 1;
	flex-flow: row nowrap;
	row-gap: 4px;
	p {
		font-size: var(--font-size-l);
		line-height: 100%;
	}
`;

export const BackButtonWrapper = styled.div`
	position: relative;
	z-index: 1000;

	& > div {
		position: absolute !important;
	}
`;

export const unreadMessagesClass = css`
	position: absolute;
	z-index: 2;
	top: -7px;
	right: -7px;
	height: auto !important;
`;
